const baseRoute =
  'comsa-environmental/:moduleBridgeHex/:subModuleBridgeHex/:plantHex/';

export default {
  // user_module_comsaEnvironmental_base: {
  //   path: baseRoute,
  //   parameters: {
  //     moduleBridgeHex: undefined,
  //     subModuleBridgeHex: undefined,
  //     plantHex: undefined,
  //   },
  // },
  user_module_comsaEnvironmental_home: {
    path: `${baseRoute}home`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_office: {
    path: `${baseRoute}office`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_office_normal_environmental_aspects: {
    path: `${baseRoute}office/normal-environmental-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_office_emergency_and_potential_environmental_aspects: {
    path: `${baseRoute}office/emergency-and-potential-environmental-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_office_changes_management: {
    path: `${baseRoute}office/changes-management`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_office_notes_and_observations: {
    path: `${baseRoute}office/notes-and-observations`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction: {
    path: `${baseRoute}construction/`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_data_input: {
    path: `${baseRoute}construction/data-input`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_design: {
    path: `${baseRoute}construction/design`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_design_normal_aspects: {
    path: `${baseRoute}construction/design-normal-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_use_normal_aspects: {
    path: `${baseRoute}construction/use-normal-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_control_card: {
    path: `${baseRoute}construction/control-card`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_normal_aspects: {
    path: `${baseRoute}construction/construction-normal-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_deconstruction_normal_aspects: {
    path: `${baseRoute}construction/deconstruction-normal-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_emergency_potentials_aspects: {
    path: `${baseRoute}construction/emergency-potentials-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_construction_ppi: {
    path: `${baseRoute}construction/ppi`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial: {
    path: `${baseRoute}industrial`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial_data_input: {
    path: `${baseRoute}industrial/data-input`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial_design_normal_aspects: {
    path: `${baseRoute}industrial/design-normal-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial_use_normal_aspects: {
    path: `${baseRoute}industrial/use-normal-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial_control_card: {
    path: `${baseRoute}industrial/control-card`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial_normal_aspects: {
    path: `${baseRoute}industrial/construction-normal-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial_deconstruction_normal_aspects: {
    path: `${baseRoute}industrial/deconstruction-normal-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial_emergency_potentials_aspects: {
    path: `${baseRoute}industrial/emergency-potentials-aspects`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_comsaEnvironmental_industrial_ppi: {
    path: `${baseRoute}industrial/ppi`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
};
